import { getCountryByIP } from "../apis/GetIPAPI";
import { setCountry, setIsEuro } from "../store/countrySlice";
import i18n from "../i18n/i18n";

const europeanCountries = ["GB", "DE", "FR"];

const LANGUAGE_BY_COUNTRY = {
  CA: "en-CA",
  DE: "de-DE",
  ES: "es",
  FR: "en",
  GB: "en-GB",
  MX: "es-MX",
  US: "en-US",
};

export const getLanguageByCountry = (countryCode) =>
  LANGUAGE_BY_COUNTRY[countryCode?.toUpperCase()] || "en";

export const getLocation = async (dispatch) => {
  if (typeof dispatch !== "function") {
    throw new TypeError("getLocation requires a Redux dispatch function");
  }
  try {
    const res = await getCountryByIP();
    var data = res.data.data;
    if (data) {
      const countryCode = data.country?.toUpperCase();
      const language = getLanguageByCountry(countryCode);
      await i18n.changeLanguage(language);
      document.documentElement.lang = language;
      isEuropeanCountries(dispatch, countryCode);
      dispatch(setCountry(countryCode));
    }
  } catch (error) {
    console.error("Failed to get IP location:", error);
  }
};

export const isEuropeanCountries = (dispatch, country_code) => {
  let isEuro = europeanCountries.includes(country_code?.toUpperCase());
  return dispatch(setIsEuro(isEuro));
};
